import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchMrdAppTranslations = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getTranslationsDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      impcCode: payload.params.impcCode,
    },
  });
  return axios.get(serviceURL);
};

export const apiEditTranslations = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'upsertTranslationDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceURL, payload);
};
